import styled from "styled-components";
import LoginBackground from "../assets/background.png";
import { BasePageContainer } from "../GlobalStyles.styles";

export const StyledLogin = styled(BasePageContainer)`
    background: url(${LoginBackground});
    background-size: cover;
`;

export const StyledLoginMobile = styled(BasePageContainer)`
    background: url(${LoginBackground});
    background-size: cover;
`;
